<template>
  <!--  NEW: hide navbar on any account page  -->
  <nav v-if="!hideOnAccount" class="fixed w-full z-50 bg-white shadow-md">
    <!--  OLD (commented): always show  -->
    <!-- <nav class="fixed w-full z-50 bg-white shadow-md"> -->

    <div class="container xl:max-w-[1280px] mx-auto sm:px-3 flex justify-between items-center gap-0 px-4">
      <router-link to="/">
        <div class="flex items-center  h-[55px] sm:h-[62px] w-[100px] sm:w-[130px] ">
          <img class="sm:object-contain" src="../assets/images/logo-nav.png" alt="navbar">
        </div>
      </router-link>

      <!-- Navigation Links -->
      <ul class="hidden lg:flex gap-4 text-[14px] font-medium ml-auto mr-5">
        <li><router-link :to="{ name: 'account.shipments' }" :class="getActiveClass('account.shipments')">Ship
            Now</router-link></li>
        <li><router-link :to="{ name: 'calculator' }" :class="getActiveClass('calculator')">Shipping Rates</router-link>
        </li>
        <li><router-link :to="{ name: 'about' }" :class="getActiveClass('about')">About us</router-link></li>
        <li><router-link :to="{ name: 'contact-us' }" :class="getActiveClass('contact-us')">Contact us</router-link>
        </li>
      </ul>

      <div class="flex items-center gap-2 lg:text-base text-sm font-medium">
        <div class="md:flex space-x-2 items-center">
          <template v-if="token">
            <router-link to="/account">
              <button :class="name.length > 15 ? 'w-[180px]' : 'w-[140px]'"
                class="px-4 py-1.5 text-sm font-medium text-[#EEB500] bg-white border border-yellow-400 rounded-full transition hover:bg-gradient-to-r hover:from-yellow-400 hover:to-amber-600 hover:text-white hover:shadow-md focus:outline-none focus:ring-2 focus:ring-yellow-500 whitespace-nowrap overflow-hidden text-ellipsis">
                {{ name }}
              </button>
            </router-link>
          </template>
          <template v-else>
            <router-link to="/login">
              <button
                class="px-4 py-1.5 text-sm font-medium text-[#EEB500] bg-white border border-yellow-400 rounded-full transition hover:bg-gradient-to-r hover:from-yellow-400 hover:to-amber-600 hover:text-white hover:shadow-md focus:outline-none focus:ring-2 focus:ring-yellow-500 w-[100px] sm:w-[140px]">
                Login
              </button>
            </router-link>
            <router-link to="/signup">
              <button
                class="px-4 py-1.5 text-sm font-medium text-white bg-gradient-to-r from-yellow-400 to-amber-600 rounded-full transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-yellow-500 w-[100px] sm:w-[140px]">
                Register
              </button>
            </router-link>
          </template>
        </div>


        <!-- <div v-if="!token" class="block space-x-2">
          <button @click="sidebar = true"
            class="bg-gradient-to-r from-[#FFD200] to-[#CD7D00] px-3 py-1 text-white rounded-md text-base lg:text-lg hover:shadow-md flex items-center justify-center">
            <i class="fa-solid fa-bars text-white text-lg"></i>
          </button>
        </div> -->
      </div>

      <SidebarComponent v-if="sidebar" @close-sidebar="closeSidebar"></SidebarComponent>
    </div>
  </nav>
</template>

<script>
import SidebarComponent from './SidebarComponent.vue';
/*  NEW: import route helpers  */
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  name: "NavbarComponent",
  components: { SidebarComponent },
  setup() {
    const route = useRoute();
    /*  NEW: hide on any account page  */
    const hideOnAccount = computed(() =>
      String(route.name).startsWith('account') || route.name === 'account'
    );
    return { hideOnAccount };
  },
  data() {
    return {
      sidebar: false,
      token: null,
      name: null,
    };
  },
  methods: {
    syncAuthState() {
      this.token = localStorage.getItem('token');
      this.name = localStorage.getItem('name') || 'Account';
    },
    closeSidebar() {
      this.sidebar = false;
    },
    getActiveClass(routeName) {
      return this.currentRoute === routeName ? 'nav_item_active' : '';
    }
  },
  computed: {
    /*  OLD: normal currentRoute  */
    currentRoute() {
      return this.$route.name;
    }
  },
  watch: {
    $route() {
      this.syncAuthState();
    }
  },
  created() {
    window.addEventListener('auth-state-changed', this.syncAuthState);
  },
  mounted() {
    this.syncAuthState();
  },
  beforeUnmount() {
    window.removeEventListener('auth-state-changed', this.syncAuthState);
  }
};
</script>